var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 489.03 488.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.94,488.8c-3.73-2.59-7.93-4.72-11.13-7.86Q398.62,422,338.67,362.85c-1-1-2.07-1.93-3.29-3.07-1.38.94-2.71,1.76-3.94,2.7a201,201,0,0,1-89.07,39c-49,8.35-95.66,1-139-23.91-44.91-25.87-76.93-63-92.74-112.52C-10.12,200-.59,138.91,39.89,83.73c33.65-45.89,79.53-73,135.77-81.32C224.14-4.75,270,4,312.19,29.52c48.24,29.2,80.6,70.86,93.51,125.86,15.56,66.34.09,125.9-43.62,178.13-.92,1.1-1.86,2.17-2.77,3.28a14,14,0,0,0-.81,1.32c.93,1,1.94,2.11,3,3.17q59.51,58.59,119,117.24c3.3,3.26,5.71,7.44,8.53,11.19v6.68c-2.08,6.2-6.34,10.21-12.41,12.41ZM380.07,205.36c-.87-22.38-2.62-40.8-12.06-64.71A167.52,167.52,0,0,0,302.15,60c-37.33-24.28-78.36-33.08-122.48-26.53C136,39.93,99.6,60.13,71.57,94c-33.86,40.93-46.35,88.35-36.24,140.53,10.34,53.3,40.4,93.6,88.43,118.41,58.29,30.1,117.35,28.69,173.65-5.45C351.27,314.85,377.67,265.22,380.07,205.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSearchIcon);
export default __webpack_public_path__ + "static/media/nav-search-icon.34288f0ccecb8efa02974409da885aca.svg";
export { ForwardRef as ReactComponent };